module.exports = require("glob-parent");